export default {
  setFoodMerchants(state, payload) {
    state.foodMerchants = payload;
  },
  setFoodMerchantBranchs(state, payload) {
    state.foodMerchantBranchs = payload;
  },
};
